/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Shortcuts_KeysInputs */

const en_pc_tut_shortcuts_keys = /** @type {(inputs: Pc_Tut_Shortcuts_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mac`)
};

const zh_pc_tut_shortcuts_keys = /** @type {(inputs: Pc_Tut_Shortcuts_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mac`)
};

/**
* | output |
* | --- |
* | "Mac" |
*
* @param {Pc_Tut_Shortcuts_KeysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_shortcuts_keys = /** @type {((inputs?: Pc_Tut_Shortcuts_KeysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Shortcuts_KeysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_shortcuts_keys(inputs)
	return zh_pc_tut_shortcuts_keys(inputs)
});
export { pc_tut_shortcuts_keys as "pc.tut.shortcuts.keys" }